import React from "react";
import { Icon } from "../core/Icon.jsx";

const MONTHS = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
const pad = (n) => String(n).padStart(2, "0");
const fmt = (d) => pad(d.getDate()) + "." + pad(d.getMonth() + 1) + "." + d.getFullYear();
const parse = (s) => { const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(String(s || "")); return m ? new Date(+m[3], +m[2] - 1, +m[1]) : null; };
const same = (a, b) => a && b && a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();

export function DatePicker({ value = "", onSelect, height, style = {} }) {
  const [open, setOpen] = React.useState(false);
  const [view, setView] = React.useState(null);
  const sel = parse(value);
  const today = new Date();
  const v = view || sel || today;
  const y = v.getFullYear(), m = v.getMonth();
  const firstDow = (new Date(y, m, 1).getDay() + 6) % 7;
  const dim = new Date(y, m + 1, 0).getDate();
  const prevDim = new Date(y, m, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push({ d: prevDim - firstDow + 1 + i, out: true, mo: m - 1 });
  for (let d = 1; d <= dim; d++) cells.push({ d, out: false, mo: m });
  while (cells.length % 7) cells.push({ d: cells.length - firstDow - dim + 1, out: true, mo: m + 1 });
  const commit = (d) => { setOpen(false); setView(new Date(d)); if (onSelect) onSelect(fmt(d)); };
  const navBtn = { display: "flex", alignItems: "center", justifyContent: "center", width: 24, height: 24, background: "transparent", border: "1px solid var(--line-d)", borderRadius: 5, color: "var(--fg-6)", cursor: "pointer", padding: 0 };
  const footBtn = { height: 24, padding: "0 9px", background: "transparent", border: "1px solid var(--line-d)", borderRadius: 5, color: "var(--fg-6)", fontFamily: "inherit", fontSize: "var(--fs-11)", cursor: "pointer" };
  return (
    <div style={{ position: "relative", width: "100%", ...style }}>
      <div onClick={() => setOpen(!open)} style={{
        display: "flex", alignItems: "center", gap: 6, width: "100%", height: height || 26, padding: "0 8px",
        background: "var(--bg-field)", border: "1px solid " + (open ? "var(--line-l)" : "var(--line-d)"), borderRadius: "var(--r-field)",
        color: value ? "var(--fg-1)" : "var(--fg-6b)", fontSize: "var(--type-value-size)", cursor: "pointer",
      }}>
        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{value || "--.--.----"}</span>
        <Icon name="calendar" size={15} style={{ color: "var(--ico-d)" }} />
      </div>
      {open ? (
        <React.Fragment>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 70 }} />
          <div style={{ position: "absolute", left: 0, top: (height || 26) + 4, zIndex: 71, width: 252, background: "var(--bg-pop)", border: "1px solid var(--line-b)", borderRadius: "var(--r-popover)", boxShadow: "var(--shadow-popover)", padding: 10 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 2px 8px" }}>
              <button onClick={() => setView(new Date(y, m - 1, 1))} style={navBtn}><Icon name="chevron-left" size={14} /></button>
              <span style={{ fontSize: "var(--fs-12)", fontWeight: "var(--fw-semibold)", color: "var(--fg-1)" }}>{MONTHS[m] + " " + y}</span>
              <button onClick={() => setView(new Date(y, m + 1, 1))} style={navBtn}><Icon name="chevron-right" size={14} /></button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 2, paddingBottom: 2 }}>
              {["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"].map((d) => <div key={d} style={{ height: 22, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "var(--fs-10)", color: "var(--fg-9)" }}>{d}</div>)}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 2 }}>
              {cells.map((c, i) => {
                const date = new Date(y, c.mo, c.d);
                const isSel = same(date, sel), isToday = same(date, today);
                return <button key={i} onClick={() => commit(date)} style={{
                  height: 26, display: "flex", alignItems: "center", justifyContent: "center",
                  border: isToday && !isSel ? "1px solid color-mix(in srgb, var(--ac-blue) 55%, transparent)" : "1px solid transparent",
                  borderRadius: 5, background: isSel ? "var(--ac-blue)" : "transparent",
                  color: isSel ? "#0b1420" : c.out ? "var(--fg-10)" : "var(--fg-3)",
                  fontFamily: "inherit", fontSize: "var(--fs-11)", fontWeight: isSel ? "var(--fw-semibold)" : "var(--fw-regular)", cursor: "pointer", padding: 0,
                }}>{c.d}</button>;
              })}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, paddingTop: 8, marginTop: 8, borderTop: "1px solid var(--line-f)" }}>
              <button onClick={() => { setOpen(false); if (onSelect) onSelect(""); }} style={footBtn}>Leeren</button>
              <button onClick={() => commit(today)} style={{ ...footBtn, color: "var(--fg-4)" }}>Heute</button>
            </div>
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
}
